/* eslint-disable no-useless-escape */
import React, {} from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Loader2, Portal } from 'components';
import { useRequest } from 'hooks';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;

	h2 {
		margin: 0 !important;
	}

	label {
		color: ${props => props.theme.darkBlue};
		font-size: 16px;
		font-weight: 500;
		line-height: normal;
	}

	@media (min-width: 660px) {
		.short {
			width: 250px;
		}
	}

`;

const Row = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;

	@media (min-width: 660px) {
		flex-direction: row;
		gap: 20px;
	}
`;

const Block = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const Row1 = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	align-items: center;
	
`;

const IconLink = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path fillRule="evenodd" clipRule="evenodd" d="M12 1C12 0.447715 12.4477 0 13 0H19C19.5523 0 20 0.447715 20 1L20 7C20 7.55228 19.5523 8 19 8C18.4477 8 18 7.55229 18 7L18 3.41421L11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289L16.5858 2H13C12.4477 2 12 1.55228 12 1ZM5.7587 2L8 2C8.55229 2 9 2.44772 9 3C9 3.55228 8.55229 4 8 4H5.8C4.94342 4 4.36113 4.00078 3.91104 4.03755C3.47262 4.07337 3.24842 4.1383 3.09202 4.21799C2.7157 4.40973 2.40973 4.71569 2.21799 5.09202C2.1383 5.24842 2.07337 5.47262 2.03755 5.91104C2.00078 6.36113 2 6.94342 2 7.8V14.2C2 15.0566 2.00078 15.6389 2.03755 16.089C2.07337 16.5274 2.1383 16.7516 2.21799 16.908C2.40973 17.2843 2.7157 17.5903 3.09202 17.782C3.24842 17.8617 3.47262 17.9266 3.91104 17.9624C4.36113 17.9992 4.94342 18 5.8 18H12.2C13.0566 18 13.6389 17.9992 14.089 17.9624C14.5274 17.9266 14.7516 17.8617 14.908 17.782C15.2843 17.5903 15.5903 17.2843 15.782 16.908C15.8617 16.7516 15.9266 16.5274 15.9624 16.089C15.9992 15.6389 16 15.0566 16 14.2V12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12V14.2413C18 15.0463 18 15.7106 17.9558 16.2518C17.9099 16.8139 17.8113 17.3306 17.564 17.816C17.1805 18.5686 16.5686 19.1805 15.816 19.564C15.3306 19.8113 14.8139 19.9099 14.2518 19.9558C13.7106 20 13.0463 20 12.2413 20H5.75868C4.95372 20 4.28936 20 3.74817 19.9558C3.18608 19.9099 2.66937 19.8113 2.18404 19.564C1.43139 19.1805 0.819469 18.5686 0.435975 17.816C0.188684 17.3306 0.0901197 16.8139 0.0441945 16.2518C-2.28137e-05 15.7106 -1.23241e-05 15.0463 4.31292e-07 14.2413V7.7587C-1.23241e-05 6.95373 -2.28137e-05 6.28937 0.0441945 5.74817C0.0901197 5.18608 0.188684 4.66937 0.435975 4.18404C0.819468 3.43139 1.43139 2.81947 2.18404 2.43597C2.66937 2.18868 3.18608 2.09012 3.74818 2.04419C4.28937 1.99998 4.95373 1.99999 5.7587 2Z" fill="currentColor"/>
	</svg>
);

const Content = ({data}) => {
	const { t } = useTranslation();
	const lang = i18n.language;

	const {
		data: Response,
		loading,
	} = useRequest(
		{
			HotelRequest: {
				ActionDescription: {
					Parameters: {
						HotelCode: data
					}
				}
			}
		},
		{
		}
	);

	const hotel = (Response?.Hotel?.[0] ?? false);

	const onReestr = (hotel?.FSA?.CertificateSerial ?? '').length > 0;

	if (loading) {
		return (
			<Container>
				<Loader2 />
			</Container>
		);
	}

	return (
		<>
			{hotel && <Container>
				<h2>{hotel?.Name}</h2>

				<Row1>{hotel?.City?.Name}, {hotel?.Country?.Name}</Row1>

				{onReestr && <>
					<Row>
						<Block className='short'>
							<label>{t('Статус сертификации')}</label>
							{hotel?.FSA?.FSAHotelStatus?.Name ?? t('Нет данных')}
						</Block>

						<Block>
							<label>{t('Официальная категория')}</label>
							<Row1>{(hotel?.Stars?.OfficialCertificate?.Certificate?.Url ?? '').length > 0 && <img src={hotel?.Stars?.OfficialCertificate?.Certificate?.Url ?? ''} />} {hotel?.Stars?.OfficialCertificate?.Certificate?.Name ?? t('Нет данных')}</Row1>
						</Block>
					</Row>

					<Row>
						<Block className='short'>
							<label>{t('Дата начала действия')}</label>
							{hotel?.FSA?.CertificateBeginDate ?? t('Нет данных')}
						</Block>

						<Block className='short'>
							<label>{t('Дата окончания действия')}</label>
							{hotel?.FSA?.CertificateExpired ?? t('Нет данных')}
						</Block>
					</Row>

					<Row>
						<Block className='short'>
							<label>{t('Тип объекта размещения')}</label>
							{hotel?.ObjType?.Name ?? t('Нет данных')}
						</Block>

						<Block className='short'>
							<label>{t('Номер реестровой записи')}</label>
							{hotel?.FSA?.CertificateSerial ?? t('Нет данных')}
						</Block>
					</Row>

					<Block>
						<label>{t('Идентификационный номер средства размещения')}</label>
						{hotel?.FSA?.FSAResortId ?? t('Нет данных')}
					</Block>

					<a href={(hotel?.FSA?.FSAResortId ?? '').length > 0 ? `https://tourism.fsa.gov.ru/${lang}/resorts/hotels/${hotel?.FSA?.FSAResortId}/about-resort`:`https://tourism.fsa.gov.ru/${lang}/resorts/showcase/hotels`} target='_blank' rel="noreferrer">
						<IconLink /> {t('Объект размещения в Национальной системе аккредитации')}
					</a>

				</>}

				{!onReestr && <>
					{Number(hotel?.Country?.Code) === 9 && <Block>
						<label>{t('Объект размещения не включен в Единый реестр объектов классификации в сфере туристической индустрии Российской Федерации')}</label>
					</Block>}

					<Block>
						<label>{t('Уровень')}</label>
						<Row1>{hotel?.Stars?.Code !==6 && <img src={hotel?.Stars?.Url ?? ''} />} {hotel?.Stars?.Name}</Row1>
					</Block>

					<Row1>{t('Сведения об уровне объекта размещения предоставлены самим поставщиком')}</Row1>

				</>}

			</Container>}

			{!hotel && <Container>
				{t('Информация не доступна')}
			</Container>}
		</>
	);
};

export const ModalCategoryHotel = ({ data = false, setData }) => {
	const onClose = () => setData(false);
	return (
		<Portal isOpen={data !== false} width='560' onClose={onClose}>
			{data !== false && <Content data={data} setData={setData} />}
		</Portal>
	);
};
